import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import moment from "moment";
import Axios from "axios";

//STYLES
import * as MobileCalendarViewStyles from "../styles/mobileCalendarView";

//COMPONENTS
import MobileDayView from "./mobileDayView";

function MobileCalendarView() {
    const dayRef = useRef(null);
    const [dayWidth, setDayWidth] = useState(0);
    const [isLoaded, setIsLoaded] = useState(false);

    const [month, setMonth] = useState({
        monthText: "",
        days: [],
        currentDate: "",
        dateMonth: ""
    });

    const [dayViewModal, setDayViewModal] = useState({
        open: false,
        events: [],
        dateNumber: ""
    });

    function handleCloseDayViewModal() {
        setDayViewModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        if (dayRef != null) {
            setDayWidth(dayRef.current.offsetWidth);
        }
        openMonth(moment());
    }, []);

    function openMonth(date) {
        const data = { monthIndex: `${moment(date).format("MM")}-${moment(date).format("YY")}` };
        Axios.post("/pods/events/getMonthBookings", data)
            .then((res) => {
                const data = res.data;
                //console.log(data);

                let monthText = "";
                let dateMonth = "";
                if (moment(date).format("YYYY") != moment().format("YYYY")) {
                    monthText = `${moment(date).format("MMMM")} ${moment(date).format("YYYY")}`;
                } else {
                    monthText = moment(date).format("MMMM");
                }

                dateMonth = `${moment(date).format("MMMM")} ${moment(date).format("YYYY")}`;

                const startOfMonth = moment(date).startOf("month");
                let startDate = startOfMonth.startOf("week");
                const endOfMonth = moment(date).endOf("month");
                const finishDate = endOfMonth.endOf("week");

                let days = [];
                let week = [];
                let dayOfWeek = 0;
                while (startDate.isSameOrBefore(finishDate)) {
                    if (startDate.format("MMMM") == moment(date).format("MMMM")) {
                        week.push({
                            date: startDate.format("D"),
                            events: data.bookings.filter((event) =>
                                event.dayIndex.includes(`${moment(startDate).format("DD")}-${moment(startDate).format("MM")}`)
                            )
                        });
                    } else {
                        week.push("--");
                    }

                    dayOfWeek++;
                    if (dayOfWeek === 7) {
                        days.push(week);
                        week = [];
                        dayOfWeek = 0;
                    }

                    startDate.add(1, "d");
                }

                setMonth({ days: days, monthText: monthText, currentDate: moment(date).startOf("month"), dateMonth: dateMonth });
                setIsLoaded(true);
            })
            .catch((err) => console.log(err));
    }

    function handleAdvanceOneMonth() {
        setIsLoaded(false);
        const date = moment(month.currentDate).add(1, "M");
        openMonth(date);
    }

    function handleGoBackMonth() {
        setIsLoaded(false);
        const date = moment(month.currentDate).subtract(1, "M");
        openMonth(date);
    }

    function openDayView(events, dateNumber) {
        setDayViewModal((prevState) => {
            return { ...prevState, events: events, dateNumber: dateNumber, open: true };
        });
    }

    return (
        <div>
            <div style={MobileCalendarViewStyles.dayHeadings}>
                <div onClick={handleGoBackMonth}>
                    <i className="fa-solid fa-chevron-left"></i>
                </div>
                <div>{month.monthText}</div>
                <div onClick={handleAdvanceOneMonth}>
                    <i className="fa-solid fa-chevron-right"></i>
                </div>
            </div>
            <br />
            <div style={MobileCalendarViewStyles.dayHeadings}>
                <div ref={dayRef}>Sun</div>
                <div>Mon</div>
                <div>Tue</div>
                <div>Wed</div>
                <div>Thu</div>
                <div>Fri</div>
                <div>Sat</div>
            </div>
            {isLoaded && (
                <div>
                    <br />
                    {month.days.map((week, index) => {
                        return (
                            <div key={index}>
                                <div style={MobileCalendarViewStyles.dayHeadings}>
                                    {week[0] != "--" && week[0].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[0] != "--" && week[0].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[0].events, week[0].date)}
                                        >
                                            {week[0] != "--" && week[0].date}
                                        </div>
                                    )}
                                    {week[1] != "--" && week[1].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[1] != "--" && week[1].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[1].events, week[1].date)}
                                        >
                                            {week[1] != "--" && week[1].date}
                                        </div>
                                    )}
                                    {week[2] != "--" && week[2].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[2] != "--" && week[2].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[2].events, week[2].date)}
                                        >
                                            {week[2] != "--" && week[2].date}
                                        </div>
                                    )}
                                    {week[3] != "--" && week[3].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[3] != "--" && week[3].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[3].events, week[3].date)}
                                        >
                                            {week[3] != "--" && week[3].date}
                                        </div>
                                    )}
                                    {week[4] != "--" && week[4].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[4] != "--" && week[4].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[4].events, week[4].date)}
                                        >
                                            {week[4] != "--" && week[4].date}
                                        </div>
                                    )}
                                    {week[5] != "--" && week[5].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[5] != "--" && week[5].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[5].events, week[5].date)}
                                        >
                                            {week[5] != "--" && week[5].date}
                                        </div>
                                    )}
                                    {week[6] != "--" && week[6].events.length == 0 ? (
                                        <div style={{ ...MobileCalendarViewStyles.dayBox, width: `${dayWidth}px` }}>
                                            {week[6] != "--" && week[6].date}
                                        </div>
                                    ) : (
                                        <div
                                            style={{ ...MobileCalendarViewStyles.dayBoxBold, width: `${dayWidth}px` }}
                                            onClick={openDayView.bind(this, week[6].events, week[6].date)}
                                        >
                                            {week[6] != "--" && week[6].date}
                                        </div>
                                    )}
                                </div>
                                <br />
                            </div>
                        );
                    })}
                    <MobileDayView
                        open={dayViewModal.open}
                        events={dayViewModal.events}
                        dateNumber={dayViewModal.dateNumber}
                        dateMonth={month.dateMonth}
                        modalClose={handleCloseDayViewModal}
                    />
                </div>
            )}
        </div>
    );
}

export default MobileCalendarView;
